import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from 'antd';
import { notificationConstants } from '../../../../constants/notification.constants';
import { setSearchVal } from '../../store/actions';
import { searchSelector } from '../../store/selectors';
import useFilterChange from '../../hooks/useFilterChange';
import styles from './SearchQuestions.module.scss';

const { Search } = Input;

const SearchQuestions = () => {
  const dispatch = useDispatch();

  const searchVal = useSelector(searchSelector);

  const [value, setValue] = useState(searchVal);

  const change = useFilterChange({ action: setSearchVal, delay: 1 });

  const handleSearchChange = (e) => {
    setValue(e.target.value);
  };

  const handleSearch = () => {
    dispatch({
      type: notificationConstants.NOTIFICATION_CLEAR,
      payload: null,
    });

    change(value.trim());
  };

  useEffect(() => {
    setValue(searchVal);
  }, [searchVal]);

  return (
    <Search
      className={styles.root}
      placeholder="Найти"
      value={value}
      onChange={handleSearchChange}
      onSearch={handleSearch}
      enterButton
    />
  );
};

export default SearchQuestions;
